import React from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import ContenidoChat from "./partesdelchat/contenido";

import Headerchat from "./partesdelchat/header";

export default function VentanaChat({
  foto_amigo,
  foto_usuario,
  nombre_amigo,
  edad,
  actividades,
  conversacion,
}) {
  return (
    <Box
      sx={{
        display: "grid",
        height: "100vh",
        gridTemplateRows: { md: "15% 85%", xs: "35% 74%" },
      }}
    >
      <Headerchat
        actividades={actividades}
        nombre_amigo={nombre_amigo}
        foto_amigo={foto_amigo}
        edad={edad}
      />
      <ContenidoChat
        foto_amigo={foto_amigo}
        foto_usuario={foto_usuario}
        conversacion={conversacion}
      />
    </Box>
  );
}
